import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";

export default function TRACard({ as: Component = "div", interactive = false, className, children, ...rest }) {
  return (
    <Component className={cn(styles.card, interactive && styles.cardInteractive, className)} {...rest}>
      {children}
    </Component>
  );
}
